<script setup lang="ts">
const { impersonatedCustomer } = useImpersonation()
</script>

<template>
  <!-- Sandbox identity is VIOLET across the A55 journey (a55.tech pill,
       pay.a55.tech banner) — amber reads as danger, wrong for a safe test
       account. Flask = lab semantics, matching the checkout's banner. -->
  <div
    class="flex items-center justify-center gap-2 px-4 py-2 bg-violet-500/10 dark:bg-violet-500/15 border-b border-violet-500/30 text-violet-700 dark:text-violet-300 text-sm font-medium"
    role="alert"
  >
    <UIcon name="i-lucide-flask-conical" class="size-4 shrink-0" />
    <span class="truncate">
      <!-- Compact copy on phones so the account name stays visible; full sentence from sm up -->
      <span class="sm:hidden">
        <span class="font-semibold">Test account</span>
        <template v-if="impersonatedCustomer.customerName">
          — {{ impersonatedCustomer.customerName }}
        </template>
      </span>
      <span class="hidden sm:inline">
        You are viewing a <span class="font-semibold">test account</span>
        <template v-if="impersonatedCustomer.customerName">
          — {{ impersonatedCustomer.customerName }}
        </template>. Transactions and data here are for testing only.
      </span>
    </span>
  </div>
</template>
